import * as t from 'io-ts';

import {LastWriterWinsValue, mergeLastWriterWinsValue} from './lastWriterWinsValue';

/*
 * Runtime types.
 */

export const RAiComposeAssistantCustomPrompt = t.type({
  updatedAt: t.number,
  text: t.string,
  isEnabled: t.boolean,
});

export type AiComposeAssistantCustomPrompt = t.TypeOf<typeof RAiComposeAssistantCustomPrompt> &
  LastWriterWinsValue;

/*
 * Defaults.
 */

export const defaultAiComposeAssistantCustomPrompt: AiComposeAssistantCustomPrompt = {
  updatedAt: 0,
  text: '',
  isEnabled: false,
};

/*
 * Merge strategy.
 */

export const mergeAiComposeAssistantCustomPrompt = mergeLastWriterWinsValue<AiComposeAssistantCustomPrompt>;
